import { Container, Title, Image, Center, Button, Group } from '@mantine/core'
import screenshotImg from '../assets/eventbritepricing.png'


export const PricingProof = () => {

    return (

        <Container size='lg' py='xl'>
            <Center>
                <Title order={2} mb="lg">
                    Eventbrite Pricing Screenshot
                </Title>

            </Center>
            <Center>
                <Title order={4}>
                    taken: 12/31/25
                </Title>


            </Center>
            <br />
            <br />
            <br />

            <Center>
                <Image
                    radius='md'
                    src={screenshotImg}
                    alt="Eventbrite Screenshot"
                    caption="Screenshot of Eventbrite Pricing Page"
                    withPlaceholder
                />
            </Center>
        </Container>
    )

}

export default PricingProof